<div class="rs-flex-row rs-flex-middle">
  <div class="rs-flex-columns">
    <label for="switch" id="ac-switch-text">
      <span
        class="rs-block rs-font-pxB"
        *ngIf="selectedLanguage === 'fr' || selectedLanguage === 'en'"
      >
        {{ 'tv.options.show.nl' | translate }}
      </span>
      <span class="rs-block rs-font-pxB" *ngIf="selectedLanguage === 'nl'">
        {{ 'tv.options.show.fr' | translate }}
      </span>
    </label>
  </div>
  <div class="rs-flex-columns rs-flex-grow">
    <div class="rs-switch">
      <input type="checkbox" id="switch" name="switch" role="switch" (change)="toggle($event)" />
      <label for="switch">
        <span class="rs-switch-active" aria-hidden="true">{{
          'tv.options.toggle.yes' | translate
        }}</span>
        <span class="rs-switch-inactive" aria-hidden="true">{{
          'tv.options.toggle.no' | translate
        }}</span>
      </label>
    </div>
  </div>
</div>
